"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Data = void 0;
/**
 * @module data
 * @preferred
 *
 * Data module us used to access data
 * */

var data_1 = __importDefault(require("./http/data"));

var event_1 = __importDefault(require("./event"));

var Data =
/** @class */
function () {
  function Data(expression, resolution, fixed, from, to) {
    if (to === void 0) {
      to = new Date();
    }

    this.expression = expression;
    this.resolution = resolution;
    this.fixed = fixed;
    this.from = from;
    this.to = to;
    this.result = [];
  }

  Data.prototype.get = function (credentials, baseUUID) {
    return data_1.default(credentials, this.from, this.to, this.resolution, this.expression, this.fixed, baseUUID).then(function (res) {
      var e_1, _a, e_2, _b;

      if (res.result != null) {
        try {
          for (var _c = __values(res.result), _d = _c.next(); !_d.done; _d = _c.next()) {
            var r = _d.value;
            var correctedEntries = [];

            if (r.entries != null) {
              try {
                for (var _e = (e_2 = void 0, __values(r.entries)), _f = _e.next(); !_f.done; _f = _e.next()) {
                  var e = _f.value;
                  correctedEntries.push(new event_1.default(new Date(e.age), parseFloat(e.value), e.state));
                }
              } catch (e_2_1) {
                e_2 = {
                  error: e_2_1
                };
              } finally {
                try {
                  if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally {
                  if (e_2) throw e_2.error;
                }
              }
            }

            r.entries = correctedEntries;
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
      } else {
        res.result = [];
      }

      res.from = new Date(res.from);
      res.to = new Date(res.to);
      return res;
    });
  };

  return Data;
}();

exports.Data = Data;
/*export class Data {
  selector: DataSelector;
  resolution: number; // seconds
  from: Date;
  to: Date;
  transform: Array<Transform>;
  fixed: boolean;
  result: Array<any>;

  constructor(selector: any, transform: Array<Transform>, resolution: number, fixed: boolean, from: Date, to=new Date()) {
    this.selector = selector;
    this.transform = transform;
    this.resolution = resolution;
    this.fixed = fixed;
    this.from = from;
    this.to = to;
    this.result = [];
  }
  get(node: UUID, credentials: Credentials): Promise<any> {
    return RemoteData(credentials,
      node,
      this.from,
      this.to,
      this.resolution,
      this.transform,
      this.fixed,
      this.selector.id,
      this.selector.index,
      this.selector.uri).then((res) => {
        if (res.result != null) {
          for (let r of res.result) {
            let correctedEntries = []
            for (let e of r.entries) {
              correctedEntries.push(new Entry(new Date(e.age), parseFloat(e.value), e.state))
            }
            r.entries = correctedEntries
          }
        } else {
          res.result = [];
        }
        res.from = new Date(res.from);
        res.to = new Date(res.to);
        return res
      })
  }
}*/